import { DesignService } from '../connections';

export function getByAnalysisSet(analysisSetGuid: string) {
  return DesignService.fetchFile(`analysisPdfs/byAnalysisSet/${analysisSetGuid}`);
}
